import React from 'react'
import { useState, useEffect } from 'react'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import { useReadHostServicesByMonitorRunIdQuery } from 'services/hostService'
import CircularProgress from '@mui/material/CircularProgress'
import { CalendarDialog } from './../CalendarDialog'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { HostServiceCard } from '../HostServiceCard'

type HostServiceListCardProps = {
    hostServices?: any;
    monitorId?: number;
    loading?: boolean,
    onSelectHostServiceForAvailability: (hostService: any) => void
}

export const HostServiceListCard = ({ hostServices, monitorId, loading = false, onSelectHostServiceForAvailability }: HostServiceListCardProps): JSX.Element => {
    const [openStartSpyHostServiceDialog, setOpenStartSpyHostServiceDialog] = useState<boolean>(false)

    const handleSelectHostServiceForAvailability = (hostService: any) => {
        onSelectHostServiceForAvailability(hostService)
    }

    const handleStartSpyHostService = () => {
        setOpenStartSpyHostServiceDialog(true)
    }

    const handleCloseStartSpyHostServiceDialog = () => {
        setOpenStartSpyHostServiceDialog(false)
    }



    const dataRender = () => {
        if (loading === true) {
            return (
                <Box sx={{ height: '300px' } }>
                    <CircularProgress
                        size={68}
                        sx={{
                            color: '#4caf50',
                        }}
                        />
                </Box>
            )
        }
        return hostServices?.map((hostService: any, index: number) => {
            return (              
                <Grid item key={hostService.id}>
                    <HostServiceCard
                            onStartSpyHostService={ handleStartSpyHostService }
                            hostService={hostService}
                            monitorId={monitorId}
                            onSelectHostServiceForAvailability={ handleSelectHostServiceForAvailability }
                     />
                </Grid>
            )
        })
    }

    return (
        <>
            <Grid container spacing={3} sx={{ justifyContent: 'center' }}>
                {
                    dataRender()
                }
            </Grid>



            <Dialog
                open={openStartSpyHostServiceDialog}
                onClose={handleCloseStartSpyHostServiceDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" sx={{ fontSize: '24px', fontWeight: '600'}}>
                    {"We will spy on this property"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" sx={{fontSize: '20px'}}>
                        Once changes occur you will receive notification and the results will appear under Property Results
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseStartSpyHostServiceDialog} autoFocus>
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}